export default "__VITE_ASSET__DkHWJnPB__"